<template>
  <div class="custom-data-container">
    <label class="section-label">{{ title }}</label>

    <md-icon
      v-if="isBenefit"
      class="remove-benefit-button"
      @click.native="deleteBenefit"
    >
      delete_outline
    </md-icon>

    <md-list class="custom-data-list">
      <md-list-item
        v-for="(entry, index) in entries"
        :key="entry[0]"
        :class="compact && 'compact-list-item'"
      >
        <div class="line-wrapper">
          <div class="fields-wrapper">
            <md-field
              :class="largeKeyField ? `large-field-key` : `small-field-key`"
              :md-inline="!!compact"
            >
              <label>key</label>
              <md-textarea
                v-model="entry[0]"
                md-autogrow
                class="small-input"
              />
            </md-field>

            <md-field
              class="small-field"
              :md-inline="!!compact"
            >
              <label>Value</label>
              <md-textarea
                v-model="entry[1]"
                md-autogrow
                class="small-input"
              />
            </md-field>
          </div>

          <div class="field-buttons-wrapper">
            <div class="remove-entry-wrapper">
              <md-icon
                class="remove-entry-button"
                @click.native="removeEntry(index)"
              >
                clear
              </md-icon>
            </div>

            <md-button
              v-if="compact"
              class="add-entry-button md-icon-button md-raised md-primary"
            >
              <md-icon @click.native="addEntry">
                add
              </md-icon>
            </md-button>
          </div>
        </div>
      </md-list-item>

      <md-button
        v-if="!compact"
        class="add-entry-button md-icon-button md-raised md-primary"
        style="margin: 5px auto;"
      >
        <md-icon @click.native="addEntry">
          add
        </md-icon>
      </md-button>
    </md-list>

    <label
      v-if="isBenefit"
      class="section-label"
    >Icon</label>
    <div
      v-if="isBenefit"
      class="icon-field-container"
    >
      <img
        :src="icon_url"
        alt=""
      >
      <md-field class="small-field">
        <label>Icon URL</label>
        <md-input
          v-model="icon_url"
          class="small-input"
        />
      </md-field>
    </div>
  </div>
</template>
<script>
    export default {
        props: {
            data: { type: Array, required: true },
            index: { type: Number, required: true },
            icon: { type: String, default: "" },
            isBenefit: Boolean,
            largeKeyField: Boolean,
            compact: Boolean,
        },
        data() {
            return {
                title: this.$props.data[0],
                // adding empty row, if there is no incoming entries
                entries: Object.keys(this.$props.data[1]).length === 0
                    ? [["", ""]]
                    : Object.entries(this.$props.data[1]),
                icon_url: this.$props.icon,
            };
        },
        watch: {
            entries() {
                this.onUpdate();
            },
            icon_url() {
                this.onUpdate();
            }
        },
        methods: {
            addEntry() {
                this.entries.push(["",""]);
            },
            removeEntry(index) {
                this.entries.splice(index, 1);
            },
            onUpdate() {
                const returnValue = this.entries.filter(([k, v]) => (k.length > 0) && (v.length > 0));
                this.$emit("update", {
                    index: this.index,
                    newValue: Object.fromEntries(returnValue),
                    icon: this["icon_url"]
                });
            },
            deleteBenefit() {
                this.$emit("delete-benefit");
            },
        }
    };
</script>
<style lang="scss">
    .custom-data-container {
        width: 100%;
        border: 2px #EEE solid;
        border-radius: 3px;
        padding: 6px 6px 0 6px;
        margin-bottom: 5px;
        position: relative;
    }

    .section-label {
        text-transform: capitalize;
    }

    .custom-data-list {
        padding: 0 !important;
    }

    .compact-list-item {
        .md-list-item-container > .md-list-item-content {
            padding: 0 !important;
            margin-top: -10px;

            .large-field-key {
                width: 200px;
                min-width: 60px;
            }

            .small-field {
                width: 300px;
                min-width: 70px;
            }
        }
    }

    @media only screen and (max-width: 500px) {
        .line-wrapper {
            display: flex;
            flex-direction: column;
            max-width: 100%;

            .fields-wrapper {
                max-width: 100%;
                .large-field-key {
                    width: calc(50% - 28px) !important;
                }
            }

            .field-buttons-wrapper {
                display: flex;
                flex-direction: row-reverse;
                justify-content: space-between;
            }
        }
    }

    .small-list-item {
        margin-bottom: -2px;
    }

    .autocomplete-item {
        width: 100%;
        font-size: 12px;
    }

    .small-field {
        margin-top: -10px !important;
        margin-bottom: 5px !important;
        width: calc(50% - 28px) !important;
        flex-grow: 2;
    }
    .small-field-key {
        @extend .small-field;
        margin-right: 10px !important;
        max-width: 100px !important;
    }
    .large-field-key {
        @extend .small-field;
        margin-right: 15px !important;
        max-width: 200px !important;
    }
    .small-input {
        padding: 0;
    }

    .line-wrapper {
        width: 100%;
        display: flex;
    }
    .fields-wrapper {
        flex-grow: 2;
        //max-width: 80%;
        display: flex;
    }

    .field-buttons-wrapper {
        flex-grow: 0;
        display: flex;
    }

    .add-entry-button {
        margin: 0 auto 8px auto;
        height: 30px;
    }
    .remove-entry-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: center;

      .remove-entry-button {
        font-size: 18px !important;
        margin-left: 5px;
      }
    }


    .remove-benefit-button {
        position: absolute;
        top: 0;
        right: 0;
        margin: 0;
        font-size: 18px !important;
    }

    .icon-field-container {
        padding: 0 15px 18px 15px;
        display: flex;
        img {
            width: 30px !important;
            height: 30px !important;
            margin: auto 10px auto 0;
        }
    }
</style>
